/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'ai-mate.agent-header-banner-label': 'Agent banner',
  'ai-mate.agent-list.all-agents-section-title': 'All Agents',
  'ai-mate.agent-list.beta-lozenge-title': 'Beta',
  'ai-mate.agent-list.change-owner-success-flag-description': 'You changed the owner of {agentName} to {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Owner changed successfully',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Are you sure you want to delete this Agent? This action cannot be undone.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Delete "{agentName}"?',
  'ai-mate.agent-list.delete-agent-error': 'Could not delete Agent',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'Something went wrong while deleting the Agent. Try again in a few moments.',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'Failed to delete Agent',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': 'Agent is currently in use. Try again later.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'That Agent could not be found.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'You cannot delete Agents you have not created yourself. Please contact the Agent owner.',
  'ai-mate.agent-list.delete-agent-success-flag-description': 'You deleted {agentName}',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Agent deleted',
  'ai-mate.agent-list.development-section-title': 'Development Agents',
  'ai-mate.agent-list.load-more-button-loading': 'Loading more Agents...',
  'ai-mate.agent-list.load-more-button-ready': 'Load more',
  'ai-mate.agent-list.loading-agents': 'Loading Agents...',
  'ai-mate.agent-list.no-results': 'No results found for "{searchValue}"',
  'ai-mate.agent-list.recommended-agents-section-title': 'Recommended',
  'ai-mate.agent-list.searching-agents': 'Searching for Agents...',
  'ai-mate.agent-list.templates-description':
    'Use these templates to create your own developer Agent. Pick the right Agent template for your work, select Use template, then fill in the template prompt with specific details like repository, folder, language, and library. Create tailored development Agents for coding different tasks, projects, or repositories.',
  'ai-mate.agent-list.templates-lozenge-title': 'Template',
  'ai-mate.agent-list.templates-title': 'Coding templates',
  'ai-mate.agent-message.agent-not-found': 'Agent not found',
  'ai-mate.agent-message.convo-title': 'Chat with {agentName} triggered from smart link embed',
  'ai-mate.agent-message.copy-link': 'Copy agent link',
  'ai-mate.agent-message.prompt': 'Prompt',
  'ai-mate.agent-message.prompt-placeholder': 'Type a message to {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Submit',
  'ai-mate.agent-message.view-profile': 'View profile',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Cancel',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Delete',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agent · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Chat with {agentName}',
  'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip': 'Copied URL',
  'ai-mate.agent-profile-info.copy-agent-link-tooltip': 'Copy link',
  'ai-mate.agent-profile-info.hidden-icon': 'Hidden',
  'ai-mate.agent-profile-info.hidden-tooltip': "Agent won't show in search results",
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Star Agent',
  'ai-mate.agent-selector.agent-not-found': 'Agent not found',
  'ai-mate.agent-selector.default-agent-description': 'Get answers, generate new ideas, and accelerate everyday work.',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.browse-agents-view.close-button': 'Close agents view',
  'ai-mate.profile-card-preview.actions-title': 'Actions',
  'ai-mate.profile-card-preview.agent-default-title': 'Agent',
  'ai-mate.profile-card-preview.agent-description-label': 'Description',
  'ai-mate.profile-card-preview.agent-title-label': 'Title',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Conversation starters',
  'ai-mate.profile-card-preview.empty-actions': 'None',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'None',
  'ai-mate.profile-card-preview.empty-instructions': 'None',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'None selected',
  'ai-mate.profile-card-preview.instructions-title': 'Instructions',
  'ai-mate.profile-card-preview.knowledge-title': 'Knowledge',
  'ai-mate.profile-card-preview.regenerate-label': 'Regenerate {fieldName}',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} - Copy',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'Drag to reorder',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'Could not save changes',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'An unknown error occurred. Please try again',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'An Agent with this name already exists',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Remove',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text':
    'Generate conversation starters',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    "{fieldName} can't exceed {maxLength, plural, one {# character} other {# characters}}",
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Next',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Restart',
  'conversation-assistant-agent.create-agent.review-agent-button-label.non-final': 'Review agent',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'Skip to manual setup',
  'create-agent.owner-field.confirm-modal-cancel': 'Cancel',
  'create-agent.owner-field.confirm-modal-confirm': 'Yes, continue',
  'create-agent.owner-field.confirm-modal-content':
    "You're about change the owner of this Agent to {name}. By doing this, you'll no longer be able to edit or manage this Agent.",
  'create-agent.owner-field.confirm-modal-title': "You're about to lose edit access",
  'create-agent.owner-field.owner-description': 'This is the person who can edit or manage the Agent.',
  'create-agent.owner-field.owner-label': 'Owner',
  'rovo-chat-create-agent.nl-input-field.tooltip.dirty.non-final':
    "Once you're happy with the basics of your agent, select <Link>Review agent</Link> to configure the details.",
  'rovo-chat.agent-card.deactivated-name': '{name} (deactivated)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'Too many requests. Wait a moment.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Try again',
  'rovo-chat.browse-agents.all-agents-button': 'All',
  'rovo-chat.browse-agents.close-button': 'Close',
  'rovo-chat.browse-agents.create-agent-button': 'Create',
  'rovo-chat.browse-agents.create-an-agent-button': 'Create an Agent',
  'rovo-chat.browse-agents.create-button-disabled-tooltip': "You don't have permission to create agents in this site",
  'rovo-chat.browse-agents.created-by-label': '<text>by</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Coding Agents',
  'rovo-chat.browse-agents.favorite-agents-button': 'Favourites',
  'rovo-chat.browse-agents.favourited-agent-label': 'Favourited Agent',
  'rovo-chat.browse-agents.modal-title': 'Browse Agents',
  'rovo-chat.browse-agents.my-agents-button': 'My Agents',
  'rovo-chat.browse-agents.no-created-agents':
    "It looks like you haven't created any Agents yet. Start by duplicating other existing Agents or begin from scratch to create one.",
  'rovo-chat.browse-agents.no-created-agents-header': 'No Agents created yet',
  'rovo-chat.browse-agents.no-created-agents-header-no-permission': "You haven't created any agents",
  'rovo-chat.browse-agents.no-created-agents-no-permission':
    'You need permission from an admin to create Rovo agents in this site.',
  'rovo-chat.browse-agents.no-starred-agents':
    "If you've got a favourite Agent or one that you use often, star it for easy access.",
  'rovo-chat.browse-agents.no-starred-agents-header': "You haven't starred an Agent yet",
  'rovo-chat.browse-agents.search-input.placeholder': 'Search Agents',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Search Templates',
  'rovo-chat.browse-agents.see-all-agents-button': 'See all Agents',
  'rovo-chat.browse-agents.templates-button': 'Templates',
  'rovo-chat.create-agent.actions-section-description':
    'Add actions for your Agent to perform tasks in Jira, Confluence, and Jira Service Management. <link>What are Agent actions?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Add actions',
  'rovo-chat.create-agent.all-content-label': 'All content',
  'rovo-chat.create-agent.back-button': 'Go back',
  'rovo-chat.create-agent.confirm-leave-modal.body': "You haven't created your Agent yet, do you want to discard it?",
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Cancel',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Yes, discard Agent',
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Unfinished Agent',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    "Are you sure you want to discard the changes you've made to this Agent?",
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Confirm',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Restart your creation',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'People can use these to start a chat with your Agent. If you can’t think of any, we can generate them for you.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Conversation starters',
  'rovo-chat.create-agent.create-agent-button': 'Create',
  'rovo-chat.create-agent.ctions-section-title': 'Actions',
  'rovo-chat.create-agent.description-field-description':
    "People can use the description on the Agent's profile to learn more about it.",
  'rovo-chat.create-agent.description-field-label': 'Description',
  'rovo-chat.create-agent.description-field-placeholder':
    'Write a short description about your Agent (for example, creative writer for marketing blogs)',
  'rovo-chat.create-agent.instructions-field-description':
    'How do you want this Agent to behave? What can it do? <link>More on writing instructions for an Agent</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Instructions',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Customise the instructions for this Agent',
  'rovo-chat.create-agent.intro-description-part-1':
    'Create an Agent with specialized knowledge to answer questions, write and review content, and perform tasks to help you move work forward.',
  'rovo-chat.create-agent.intro-description-part-2':
    "If you don't need help, you can <bold>Skip to manual setup.</bold>",
  'rovo-chat.create-agent.intro-description-part-3': 'Otherwise, stay here and we can build one together.',
  'rovo-chat.create-agent.intro-step-1-content':
    "I'll create instructions for the Agent based on what you write. Just tell me what you're planning to use the Agent for.",
  'rovo-chat.create-agent.intro-step-1-title': 'Describe what you want your Agent to do',
  'rovo-chat.create-agent.intro-step-2-content':
    "Let's work together to decide on your Agent's name and personality. Tell me if your Agent is empathetic, direct, or funny.",
  'rovo-chat.create-agent.intro-step-2-title': 'Sprinkle in some character',
  'rovo-chat.create-agent.intro-step-3-content':
    "Hit <bold>Next</bold> to review your new Agent, add actions, knowledge, and a profile picture. When you're all finished, select <bold>Create.</bold>",
  'rovo-chat.create-agent.intro-step-3-content-skills':
    "Hit <bold>Next</bold> to review your new Agent, add skills, knowledge, and a profile picture. When you're all finished, select <bold>Create.</bold>",
  'rovo-chat.create-agent.intro-step-3-title': 'Review and create your Agent',
  'rovo-chat.create-agent.intro-title': "👋 Let's create your Agent",
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'All projects',
  'rovo-chat.create-agent.jira-filter-placeholder-galaxia': 'All spaces',
  'rovo-chat.create-agent.jsm-checkbox-label': 'Jira Service Management',
  'rovo-chat.create-agent.jsm-filter-placeholder': 'All projects',
  'rovo-chat.create-agent.knowledge-field-description':
    "Specify the Agent's knowledge by only allowing it to reference the sources you provide",
  'rovo-chat.create-agent.knowledge-field-label': 'Knowledge',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Only reference these sources',
  'rovo-chat.create-agent.knowledge-select.object-resolver-label': 'Links',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Suggested',
  'rovo-chat.create-agent.manage-actions-button-label': 'Manage actions',
  'rovo-chat.create-agent.name-field-description': 'People can use this to find the Agent.',
  'rovo-chat.create-agent.name-field-label': 'Name',
  'rovo-chat.create-agent.name-field-placeholder': 'Name your Agent',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error':
    'An unexpected error occurred. Please try again.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    "Hi! I'm here to help you build a custom Agent. Tell me what you'd like your Agent to do?",
  'rovo-chat.create-agent.nl-input-field.input-label': 'Create an agent',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Type your message',
  'rovo-chat.create-agent.nl-input-field.placeholder.dirty.non-final': 'Type a response',
  'rovo-chat.create-agent.nl-input-field.placeholder.initial.non-final': 'Describe what you want to create',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Send',
  'rovo-chat.create-agent.nl-input-field.tooltip.initial.non-final':
    'Describe what you want to create or <Link>skip to manual setup</Link>',
  'rovo-chat.create-agent.page-title': 'Create an Agent',
  'rovo-chat.create-agent.page-title-edit': 'Edit Agent',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Search for pages',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Search for spaces',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'All',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Beta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Cancel',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Close',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-discard-button.non-final': 'Discard',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    'Selecting fewer than {count, plural, one {# action} other {# actions}} results in optimal performance',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Save',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Search actions',
  'rovo-chat.create-agent.select-action-modal-title': 'Add actions',
  'rovo-chat.create-agent.select-content-under-label': 'Select content under',
  'rovo-chat.create-agent.select-spaces-label': 'Select spaces',
  'rovo-chat.create-agent.selected-actions-label': 'Selected actions:',
  'rovo-chat.create-agent.unknown-owner': 'Unknown',
  'rovo-chat.create-agent.update-agent-button': 'Update',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    "If you continue, you'll lose unsaved changes. Select Cancel to continue editing this Agent.",
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Continue, discard changes',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Discard changes',
  'rovo-chat.view-agent.about-label': 'About',
  'rovo-chat.view-agent.actions-label': 'Actions',
  'rovo-chat.view-agent.all-knowledge-added': 'All organisational knowledge',
  'rovo-chat.view-agent.behaviour-label': 'Behaviour',
  'rovo-chat.view-agent.beta-label': 'Beta',
  'rovo-chat.view-agent.beta-tag': 'Beta',
  'rovo-chat.view-agent.chat-to-agent-button': 'Chat to Agent',
  'rovo-chat.view-agent.close-button': 'Close',
  'rovo-chat.view-agent.copy-behaviour-tooltip': 'Copy behaviour',
  'rovo-chat.view-agent.copy-instructions-label': 'Copy',
  'rovo-chat.view-agent.copy-instructions-tooltip': 'Copy instructions',
  'rovo-chat.view-agent.created-by-label': '<text>by</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': '# of favourites',
  'rovo-chat.view-agent.go-back-label': 'Go back',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Forge Agents built with code have their instructions hidden for privacy.',
  'rovo-chat.view-agent.hidden-instructions-title': 'These instructions are private',
  'rovo-chat.view-agent.hidden-knowledge-description':
    "Forge Agents built with code don't use typical knowledge sources",
  'rovo-chat.view-agent.instructions-label': 'Instructions',
  'rovo-chat.view-agent.knowledge-label': 'Knowledge',
  'rovo-chat.view-agent.member-count': '{count, plural, one {# member} other {# members}}',
  'rovo-chat.view-agent.modal-title': 'Browse Agents',
  'rovo-chat.view-agent.no-actions': 'No actions',
  'rovo-chat.view-agent.no-behaviour-placeholder': 'This agent has no custom behaviour',
  'rovo-chat.view-agent.no-instruction-placeholder': 'This agent has no custom instructions',
  'rovo-chat.view-agent.no-knowledge-added': 'No organisational knowledge',
  'rovo-chat.view-agent.no-scenarios': 'No scenarios',
  'rovo-chat.view-agent.no-skills': 'No skills',
  'rovo-chat.view-agent.no-teams': 'Not part of any teams',
  'rovo-chat.view-agent.open-chat-label': 'Open chat',
  'rovo-chat.view-agent.reactions-metadata-label': '# of reactions',
  'rovo-chat.view-agent.rovo-agent-label': 'Rovo Agent',
  'rovo-chat.view-agent.scenarios-label': 'Scenarios',
  'rovo-chat.view-agent.skills-label': 'Skills',
  'rovo-chat.view-agent.teams-label': 'Teams',
  'rovo-chat.view-agent.users-metadata-label': '# of users',
};
